import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import DataExtractionUploadActionsMenu from './DataExtractionUploadActionsMenu';
import CustomPagination from '../../../components/customPagination';
import dayjs from 'dayjs';
import { fetchPdfDataExtractionRequest } from '../../../api/pdfDataExtraction/pdfDataExtractionSlice';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const PDFDataExtractionTable = ({ searchQuery = {} }) => {
  const { extractions, totalDocuments } = useSelector((state) => state.extractions);
  const { common } = useTranslatedMessages();
  const ui = common.ui;
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const dispatch = useDispatch();

  useEffect(() => {
    const query = {
      ...searchQuery,
      page: page + 1,
      limit,
    };

    dispatch(fetchPdfDataExtractionRequest({ query }));
  }, [dispatch, page, limit, searchQuery]);

  const columns = [
    {
      field: 'filename',
      headerName: ui.file_name,
      flex: 1.5,
    },
    {
      field: 'created_on',
      headerName: ui.upload_date,
      flex: 1,
      valueFormatter: (params) => {
        const timestamp = params;
        if (!timestamp) return '';
        return dayjs(timestamp).format('DD-MM-YYYY hh:mm:ss A');
      },
    },
    {
      field: 'receipt_count',
      headerName: ui.receipt_count,
      flex: 0.8,
      valueFormatter: (params) => {
        return params ? params : '-';
      },
    },
    {
      field: 'status',
      headerName: ui.status,
      flex: 0.8,
      valueFormatter: (params) => {
        return params
          ?.split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      },
    },
    {
      field: 'uploaded_by',
      headerName: ui.uploaded_by,
      flex: 1,
    },
    {
      field: 'row',
      headerName: ui.actions,
      flex: 0.5,
      sortable: false,
      renderCell: ({ row }) => <DataExtractionUploadActionsMenu row={row} />,
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={[...extractions].sort((a, b) => {
          const dateA = new Date(a.created_on).toLocaleString();
          const dateB = new Date(b.created_on).toLocaleString();
          return new Date(dateB).getTime() - new Date(dateA).getTime();
        })}
        columns={columns}
        getRowId={(row) => row._id}
        paginationMode="server"
        rowCount={totalDocuments}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: limit,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          setPage(model.page);
          setLimit(model.pageSize);
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default PDFDataExtractionTable;
